export const INPUT_SX = {
  background: 'transparent',
  p: 1.5,
  px: 2,
  borderRadius: 0,
  fontFamily: "'Fira Code', monospace",
  lineHeight: '1em',
  minHeight: 'auto',
  border: 'none',
  ':before': { content: 'none' },
};
